module.exports = __webpack_public_path__ + "static/media/newsletter-march-2019-matching.88fb7985.jpg";